import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import axiosInstance from "@/services/axiosInstance";
import { Button } from "@/components/ui/button";
import { Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useProposalStore } from "@/stores/ProposalStore";

const instance = axiosInstance();

async function generateOutline(
  searchType,
  proposal_id,
  files = [],
  attachments = [],
  documents = []
) {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("files", file);
  });

  attachments.forEach((attachment) => {
    formData.append("attachments", attachment);
  });

  documents.forEach((document) => {
    formData.append("documents", document);
  });

  formData.append("proposal_id", proposal_id);
  formData.append("search_type", searchType);

  const response = await instance.post(`/proposal/generate-outline`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 200000,
  });

  return response.data;
}

async function generateOutlineIds(search_type, proposal_id, doc_ids = []) {
  const response = await instance.post(
    `/proposal/generate-outline-ids`,
    { search_type, proposal_id, doc_ids },
    {
      timeout: 200000,
    }
  );

  return response.data;
}

export function useGenerateOutline(searchType, proposalId, pursuitId) {
  const navigate = useNavigate();
  const addOutlineDetails = useProposalStore(
    (state) => state.addOutlineDetails
  );
  return useMutation({
    mutationFn: ({ files = [], attachments = [], documents = [] }) => {
      return pursuitId
        ? generateOutlineIds(searchType, proposalId, documents)
        : generateOutline(
            searchType,
            proposalId,
            files, // uploaded files
            attachments, // contract attachments
            documents // user documents
          );
    },
    mutationKey: ["generate-outline"],
    onSuccess: (data, variables, context) => {
      const { files, attachments, documents } = variables;
      addOutlineDetails(
        searchType,
        proposalId,
        data,
        files,
        attachments,
        documents
      );
      toast.success(() => (
        <div className="flex items-center gap-4">
          Outline generated successfully.
          <Button
            variant="outline"
            size="sm"
            onClick={() =>
              navigate(`/contract/${searchType}/${proposalId}/generate`)
            }
          >
            <Eye /> View
          </Button>
        </div>
      ));
    },
  });
}
